<template>
  <div>
    <div class="card p-4 shadow-sm">
      <!-- Toast -->
      <div v-if="mostrarToast" class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1055">
        <div class="toast show align-items-center text-white" :class="toastColor">
          <div class="d-flex">
            <div class="toast-body">
              <i :class="iconoToast" class="me-2"></i>
              {{ alerta.mensaje }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" @click="cerrarToast"></button>
          </div>
        </div>
      </div>

      <!-- Encabezado -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="m-0">Promociones Habitaciones</h3>
        <button class="btn btn-success" @click="mostrarFormulario = true">Agregar Promoción</button>
      </div>

      <!-- Formulario -->
      <div v-if="mostrarFormulario" class="mb-4">
        <h5 class="mb-3">Nueva Promoción</h5>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Nombre</label>
            <input v-model="nuevaPromocion.Nombre" type="text" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Fecha Inicio</label>
            <input v-model="nuevaPromocion.FechaInicio" type="date" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Fecha Fin</label>
            <input v-model="nuevaPromocion.FechaFin" type="date" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">% Descuento</label>
            <input v-model.number="nuevaPromocion.PorcentajeDescuento" type="number" min="0" max="100" step="0.01" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Estado</label>
            <select v-model="nuevaPromocion.EstadoPromocion" class="form-select">
              <option value="1">Activa</option>
              <option value="0">Inactiva</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label">Tipos de Habitación</label>
            <select v-model="nuevaPromocion.tiposHabitacion" class="form-select" multiple>
              <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                {{ tipo.Nombre }}
              </option>
            </select>
            <small class="text-muted">Mantén Ctrl o Shift para seleccionar múltiples.</small>
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-primary me-2" @click="guardarPromocion">Guardar</button>
          <button class="btn btn-secondary" @click="cancelarFormulario">Cancelar</button>
        </div>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table class="table table-bordered text-center align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Fecha Inicio</th>
              <th>Fecha Fin</th>
              <th>% Descuento</th>
              <th>Estado</th>
              <th>Tipos Habitación</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="promociones.length === 0">
              <td colspan="7">No hay promociones registradas.</td>
            </tr>
            <tr v-for="promo in promociones" :key="promo.IdPromocion">
              <td>{{ promo.Nombre }}</td>
              <td>{{ promo.FechaInicio }}</td>
              <td>{{ promo.FechaFin }}</td>
              <td>{{ promo.PorcentajeDescuento }}%</td>
              <td>{{ promo.EstadoPromocion ? 'Activa' : 'Inactiva' }}</td>
              <td>
                <ul class="list-unstyled mb-0">
                  <li v-for="tipo in promo.tipos_habitacion" :key="tipo.IdTipoHabitacion">
                    {{ tipo.Nombre }}
                  </li>
                </ul>
              </td>
              <td>
                <button class="btn btn-primary btn-sm me-2" @click="abrirModal(promo)">Editar</button>
                <button class="btn btn-danger btn-sm" @click="abrirModalEliminar(promo)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Modal Actualizar -->
      <div v-if="mostrarModal" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Promoción</h5>
            <button type="button" class="btn-close" @click.stop="cerrarModal"></button>
          </div>
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Nombre</label>
                <input v-model="promocionEditar.Nombre" type="text" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Fecha Inicio</label>
                <input v-model="promocionEditar.FechaInicio" type="date" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Fecha Fin</label>
                <input v-model="promocionEditar.FechaFin" type="date" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">% Descuento</label>
                <input v-model.number="promocionEditar.PorcentajeDescuento" type="number" min="0" max="100" step="0.01" class="form-control" />
              </div>
              <div class="col-md-6">
                <label class="form-label">Estado</label>
                <select v-model="promocionEditar.EstadoPromocion" class="form-select">
                  <option value="1">Activa</option>
                  <option value="0">Inactiva</option>
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Tipos de Habitación</label>
                <select v-model="promocionEditar.tiposHabitacion" class="form-select" multiple>
                  <option v-for="tipo in tiposHabitacion" :key="tipo.IdTipoHabitacion" :value="tipo.IdTipoHabitacion">
                    {{ tipo.Nombre }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModal">Cancelar</button>
            <button class="btn btn-primary" @click="actualizarPromocion">Actualizar</button>
          </div>
        </div>
      </div>

      <!-- Modal Eliminar -->
      <div v-if="mostrarModalEliminar" class="modal-backdrop">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger">Confirmar Eliminación</h5>
            <button type="button" class="btn-close" @click="cerrarModalEliminar"></button>
          </div>
          <div class="modal-body">
            <p>¿Eliminar la promoción <strong>{{ promocionEliminar?.Nombre }}</strong>?</p>
          </div>
          <div class="modal-footer mt-3">
            <button class="btn btn-secondary" @click="cerrarModalEliminar">Cancelar</button>
            <button class="btn btn-danger" @click="confirmarEliminar">Eliminar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { API_URL } from "@/config/config.js";

export default {
  name: "PromocionesHabitacionGestion",
  data() {
    return {
      promociones: [],
      tiposHabitacion: [],
      mostrarFormulario: false,
      mostrarModal: false,
      mostrarModalEliminar: false,
      promocionEditar: null,
      promocionEliminar: null,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      nuevaPromocion: {
        Nombre: "",
        FechaInicio: "",
        FechaFin: "",
        PorcentajeDescuento: "",
        EstadoPromocion: "1",
        tiposHabitacion: [],
      },
    };
  },
  computed: {
    toastColor() {
      return this.alerta.tipo === "success" ? "bg-success" : "bg-danger";
    },
    iconoToast() {
      return this.alerta.tipo === "success"
        ? "bi bi-check-circle"
        : "bi bi-exclamation-circle";
    },
  },
  methods: {
    cerrarToast() {
      this.mostrarToast = false;
    },
    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },
    async obtenerPromociones() {
      const res = await axios.get(`${API_URL}/promociones-habitaciones`);
      this.promociones = res.data;
    },
    async obtenerTiposHabitacion() {
      const res = await axios.get(`${API_URL}/tipohabitacion`);
      this.tiposHabitacion = res.data;
    },
    async guardarPromocion() {
      const { Nombre, FechaInicio, FechaFin, PorcentajeDescuento, tiposHabitacion } = this.nuevaPromocion;
      if (!Nombre || !FechaInicio || !FechaFin || !PorcentajeDescuento || !tiposHabitacion.length) {
        this.mostrarAlerta("Todos los campos son obligatorios", "danger");
        return;
      }
      try {
        await axios.post(`${API_URL}/promociones-habitaciones`, this.nuevaPromocion);
        this.mostrarAlerta("Promoción agregada", "success");
        this.nuevaPromocion = { Nombre: "", FechaInicio: "", FechaFin: "", PorcentajeDescuento: "", EstadoPromocion: "1", tiposHabitacion: [] };
        this.mostrarFormulario = false;
        this.obtenerPromociones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al guardar", "danger");
      }
    },
async abrirModal(promo) {
  try {
    const res = await axios.get(`${API_URL}/promociones-habitaciones/${promo.IdPromocion}`);
    const data = res.data;

    this.promocionEditar = {
      ...data,
      // 👇 Extrae solo YYYY-MM-DD
      FechaInicio: data.FechaInicio ? data.FechaInicio.substring(0, 10) : '',
      FechaFin: data.FechaFin ? data.FechaFin.substring(0, 10) : '',
      tiposHabitacion: data.tipos_habitacion.map(t => t.IdTipoHabitacion)
    };

    this.mostrarModal = true;
  } catch (err) {
    console.error(err);
    this.mostrarAlerta("Error al cargar la promoción", "danger");
  }
}

,
    cerrarModal() {
      this.promocionEditar = null;
      this.mostrarModal = false;
    },
    async actualizarPromocion() {
      try {
        await axios.put(`${API_URL}/promociones-habitaciones/${this.promocionEditar.IdPromocion}`, this.promocionEditar);
        this.mostrarAlerta("Promoción actualizada", "success");
        this.cerrarModal();
        this.obtenerPromociones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al actualizar", "danger");
      }
    },
    abrirModalEliminar(promo) {
      this.promocionEliminar = { ...promo };
      this.mostrarModalEliminar = true;
    },
    cerrarModalEliminar() {
      this.promocionEliminar = null;
      this.mostrarModalEliminar = false;
    },
    async confirmarEliminar() {
      try {
        await axios.delete(`${API_URL}/promociones-habitaciones/${this.promocionEliminar.IdPromocion}`);
        this.mostrarAlerta("Promoción eliminada", "success");
        this.obtenerPromociones();
      } catch (error) {
        console.error(error);
        this.mostrarAlerta("Error al eliminar", "danger");
      } finally {
        this.cerrarModalEliminar();
      }
    },
    cancelarFormulario() {
      this.mostrarFormulario = false;
      this.nuevaPromocion = { Nombre: "", FechaInicio: "", FechaFin: "", PorcentajeDescuento: "", EstadoPromocion: "1", tiposHabitacion: [] };
    },
  },
  mounted() {
    this.obtenerPromociones();
    this.obtenerTiposHabitacion();
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: #fff;
  width: 600px;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}
</style>
